import { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { rewardCardAccountsChannelName } from '@/channels/utils/channelNames';

import { Props } from './types';

const RewardCardAccountsChannel = ({ children, personId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={rewardCardAccountsChannelName(personId)}>
      {children}
    </ChannelProvider>
  );
};

export default RewardCardAccountsChannel;
